import block from '@/mixins/block'

export default {
  name: 'block_image',
  mixins: [block]
}
